import type { MembershipRole } from "@productlane/db/browser"

export type MemberFilter = "all" | MembershipRole | "pending"

export const MEMBER_FILTER_LABELS: Record<MemberFilter, string> = {
	all: "All",
	ADMIN: "Admins",
	USER: "Members",
	VIEWER: "Viewers",
	pending: "Pending invites",
}

export const MEMBER_FILTER_ORDER: MemberFilter[] = [
	"all",
	"ADMIN",
	"USER",
	"VIEWER",
	"pending",
]

interface MembershipLike {
	role: string
	user?: { name: string | null; email: string | null } | null
}

interface InviteLike {
	inviteName: string | null
	inviteEmail: string | null
}

export function matchesMemberSearch(
	name: string | null | undefined,
	email: string | null | undefined,
	query: string,
): boolean {
	const q = query.trim().toLowerCase()
	if (!q) return true
	return (
		(name ?? "").toLowerCase().includes(q) ||
		(email ?? "").toLowerCase().includes(q)
	)
}

export function filterMemberships<T extends MembershipLike>(
	memberships: T[],
	filter: MemberFilter,
	query: string,
): T[] {
	if (filter === "pending") return []
	return memberships.filter(
		(m) =>
			!!m.user &&
			(filter === "all" || m.role === filter) &&
			matchesMemberSearch(m.user.name, m.user.email, query),
	)
}

export function filterInvites<T extends InviteLike>(
	invites: T[],
	filter: MemberFilter,
	query: string,
): T[] {
	if (filter !== "all" && filter !== "pending") return []
	return invites.filter((i) =>
		matchesMemberSearch(i.inviteName, i.inviteEmail, query),
	)
}
